"use client";

import { EmailVerificationStep } from "@/components/onboarding/email-verification-step";
import { useRouter } from "next/navigation";
import { useSession } from "@/lib/auth-client";
import { useCallback, useEffect } from "react";
import { useStepper } from "@ocr-monorepo/ui/components/stepper";

export function VerifyEmailPageClient() {
  const router = useRouter();
  const { data: session } = useSession();
  const { setActions } = useStepper();

  const handleEmailVerified = useCallback(() => {
    router.push("/getting-started/plan");
  }, [router]);

  useEffect(() => {
    setActions({
      onNext: () => {
        const button = document.querySelector<HTMLButtonElement>(
          "[data-email-verify]",
        );
        button?.click();
      },
    });

    return () => setActions({});
  }, [setActions, handleEmailVerified]);

  return (
    <EmailVerificationStep
      email={session?.user?.email || ""}
      onNext={handleEmailVerified}
    />
  );
}
